module.exports = __webpack_public_path__ + "d0bfd72cb121d5f43916a76a07be5b47.png";


//////////////////
// WEBPACK FOOTER
// ./public/banner_3@2x.png
// module id = 190
// module chunks = 1